function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      if (this.subtract) {
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      }
      if (this.add) {
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));
      }

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min && this.subtract) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max && this.add) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card--featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener('mouseover', () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-card--featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled') || size.classList.contains('loading')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              throw new Error(errorData.description || errorData.message || 'Failed to add item to cart');
            });
          }
          return response.json();
        })
            .then((response) => {
              if (response.status) {
            const errorMessage = response.description || response.message || 'This item is unavailable. Please try a different option.';
            console.error('[Product Card Size Selector] Add to cart failed:', {
              status: response.status,
              message: errorMessage,
              response: response,
              variantId: this.currentVariant?.id
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
          console.error('[Product Card Size Selector] Add to cart error:', {
            error: e,
            message: e.message,
            variantId: this.currentVariant?.id
          });
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
          // Re-enable after a short delay to prevent rapid double-taps on mobile
          setTimeout(() => {
            if (size && !size.classList.contains('is-disabled')) {
              size.removeAttribute('aria-disabled');
            }
          }, 300);
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled || this.quick_add.classList.contains('loading')) {
        return;
      }
      
      // Get the correct variant ID - use currentVariant if size is selected, otherwise use the initial variant
      let variantId = this.quick_add.dataset.productId;
      if (this.currentVariant && this.currentVariant.id) {
        variantId = this.currentVariant.id;
      } else if (this.quick_add.dataset.variantId) {
        variantId = this.quick_add.dataset.variantId;
      }
      
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);
      this.quick_add.disabled = true;

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              throw new Error(errorData.description || errorData.message || 'Failed to add item to cart');
            });
          }
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            const errorMessage = response.description || response.message || 'This item is unavailable. Please try a different option.';
            console.error('[Product Card Quick Add] Add to cart failed:', {
              status: response.status,
              message: errorMessage,
              response: response,
              variantId: variantId
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error('[Product Card Quick Add] Add to cart error:', {
            error: e,
            message: e.message,
            variantId: variantId
          });
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
          this.quick_add.disabled = false;
          // Re-enable after a short delay to prevent rapid double-taps on mobile
          setTimeout(() => {
            if (this.quick_add && !this.quick_add.hasAttribute('disabled')) {
              this.quick_add.disabled = false;
            }
          }, 300);
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (this.cc && !this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');
      if (!panel) return;

      // Cancelar cualquier fetch en progreso del quick-view y llamar hidePopup
      const quickViewElements = document.querySelectorAll('quick-view');
      quickViewElements.forEach(qv => {
        if (typeof qv.hidePopup === 'function') {
          qv.hidePopup();
        } else {
          // Fallback para elementos que no tienen el método optimizado
          if (qv.currentFetch) {
            qv.currentFetch.abort();
            qv.currentFetch = null;
          }
          qv.isLoading = false;
          qv.classList.remove('loading');
        }
      });

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
        // Limpiar contenido inmediatamente en mobile
        const content = panel.querySelector('#Product-Drawer-Content');
        if (content) content.innerHTML = '';
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            const content = panel.querySelector('#Product-Drawer-Content');
            if (content) content.innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      // Add functionality to buttons
      if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();
        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });
        dispatchCustomEvent('cart-drawer:open');
      });
      }

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      // isConnected: el cambio llega 300 ms tarde (debounce); si la bolsa ya se redibujó, ese número de línea es viejo
      if (event.target.classList.contains('qty') && event.target.isConnected) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          // remove y no event.target: el clic puede caer en el ícono de adentro, que no lleva data-index
          this.updateQuantity(remove.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      let notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      const notesElement = document.getElementById('mini-cart__notes');
      if (!notesElement) return;
      
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': notesElement.value
        })
      });
    }
    // Cola de cambios (AoA 2026-10-30, Bryan: «le doy click al tacho y no se borra el producto»): cada cambio sale cuando
    // termina el anterior, en el orden de los clics. Antes el tacho pulsado mientras la línea se actualizaba (1 a 3 s tras
    // un +) se perdía, y dos cambios a la vez podían llegar al revés. Va por número de línea (la clave de Shopify cambia
    // cuando entra o sale un descuento automático); cuando un borrado termina, los cambios en espera de esa línea se
    // descartan y los de las líneas de abajo suben un número.
    updateQuantity(line, quantity) {
      const cambio = { line: Number(line), quantity };
      this.querySelector(`#CartDrawerItem-${cambio.line}`)?.classList.add('thb-loading');
      this.pendientes = this.pendientes || [];
      this.pendientes.push(cambio);
      this.cola = (this.cola || Promise.resolve()).then(() => {
        this.pendientes.splice(this.pendientes.indexOf(cambio), 1);
        if (cambio.descartado) return;
        return this.sendQuantity(cambio.line, cambio.quantity).then((ok) => {
          if (!ok || String(cambio.quantity) !== '0') return;
          this.pendientes.forEach((otro) => {
            if (otro.line === cambio.line) otro.descartado = true;
            else if (otro.line > cambio.line) otro.line -= 1;
          });
        });
      });
      return this.cola;
    }
    sendQuantity(line, quantity) {
      const item = this.querySelector(`#CartDrawerItem-${line}`);
      item?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      return fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          // Solo si la bolsa se redibujó: con un error los botones son los mismos y volver a engancharlos duplicaría
          // cada clic
          if (parsedState.sections) {
            this.removeProductEvent();
            this.notesToggle();
          }
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          item?.classList.remove('thb-loading');
          return Boolean(parsedState.sections);
        })
        .catch(() => {
          // Sin red o respuesta rara: la línea vuelve a quedar usable y la cola sigue
          item?.classList.remove('thb-loading');
          return false;
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 *  Optimizado para mejor performance y UX
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
      // Cache para productos ya cargados
      this.contentCache = new Map();
      this.currentFetch = null;
      this.isLoading = false;
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
    }
    
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle;

      if (!productHandle) {
        return;
      }
      
      // Prevenir múltiples clicks mientras carga
      if (this.isLoading) {
        return;
      }
      
      // Mostrar popup inmediatamente (permite cerrar durante carga)
      this.showPopupImmediately();
      
      // Verificar cache primero
      if (this.contentCache.has(productHandle)) {
        const cachedContent = this.contentCache.get(productHandle);
        this.renderQuickview(cachedContent, productHandle);
        return;
      }
      
      // Usar section rendering de Shopify (más rápido que cargar página completa)
      // Usar el método view=quick-view que funcionaba antes (más confiable)
      // Aunque es un poco más lento, garantiza que todo el contenido se renderice correctamente
      const productUrl = `/products/${productHandle}?view=quick-view`;
      
      // Debug: verificar URL (solo en desarrollo)
      if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
        console.log('Quick View URL:', { productUrl, productHandle });
      }
      
      this.isLoading = true;
      this.classList.add('loading');
      
      // Abort controller para cancelar fetch si se cierra el popup
      const abortController = new AbortController();
      this.currentFetch = abortController;
      
      // Usar método view=quick-view (el que funcionaba antes)
      fetch(productUrl, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html'
        },
        signal: abortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
              console.warn('Quick view response not OK:', response.status, response.statusText);
            }
            throw new Error(`Quick view failed: ${response.status}`);
          }
          return response.text();
        })
        .then(text => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          
          // Buscar el contenido del drawer en la respuesta
          // El método view=quick-view devuelve el template completo
          let drawerContent = doc.querySelector('#Product-Drawer-Content');
          
          if (!drawerContent) {
            // Buscar alternativas si no se encuentra directamente
            drawerContent = doc.querySelector('.product-drawer .side-panel-content') ||
                          doc.querySelector('.side-panel-content') ||
                          doc.querySelector('.thb-product-detail');
          }
          
          if (drawerContent && drawerContent.innerHTML.trim()) {
            const sectionInnerHTML = drawerContent.innerHTML;
            
            // Debug: verificar contenido antes de cachear
            if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = sectionInnerHTML;
              const productInfo = tempDiv.querySelector('#ProductInfo-main-product-quick-view');
              console.log('Quick view content extracted:', {
                contentLength: sectionInnerHTML.length,
                hasProductInfo: !!productInfo,
                productInfoLength: productInfo?.innerHTML?.length || 0,
                productInfoPreview: productInfo?.innerHTML?.substring(0, 200) || 'empty'
              });
            }
            
            // Cachear y renderizar
            this.contentCache.set(productHandle, sectionInnerHTML);
            this.renderQuickview(sectionInnerHTML, productHandle);
          } else {
            throw new Error('No content found in quick view response');
          }
        })
        .catch(error => {
          if (error.name !== 'AbortError') {
            // Solo mostrar error si no es un error de red común (apps de terceros, etc)
            if (!error.message || (!error.message.includes('Failed to fetch') && !error.message.includes('NetworkError'))) {
              console.warn('Error loading quick view:', error);
            }
            this.hidePopup();
          }
          this.isLoading = false;
          this.classList.remove('loading');
          this.currentFetch = null;
        });
    }
    
    /**
     * Mostrar popup inmediatamente (antes de cargar contenido)
     * Permite cerrar durante la carga
     */
    showPopupImmediately() {
      if (!this.drawer) return;
      
      // Mostrar loading state en el drawer
      const content = this.drawer.querySelector('#Product-Drawer-Content');
      if (content && !content.querySelector('.quick-view-loading')) {
        content.innerHTML = '<div class="quick-view-loading" style="padding: 40px; text-align: center;"><div class="loading-spinner"></div><p>Cargando producto...</p></div>';
      }
      
      // Abrir drawer inmediatamente
        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

      // Focus en botón de cerrar para permitir cerrar inmediatamente
      const closeBtn = this.drawer.querySelector('.side-panel-close');
      if (closeBtn) {
        closeBtn.focus();
      }
      
      // Permitir cerrar con ESC inmediatamente
      const escapeHandler = (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('active')) {
          this.hidePopup();
          document.removeEventListener('keydown', escapeHandler);
        }
      };
      document.addEventListener('keydown', escapeHandler);
    }
    
    /**
     * Ocultar popup y limpiar
     */
    hidePopup() {
      // Cancelar fetch si está en progreso
      if (this.currentFetch) {
        this.currentFetch.abort();
        this.currentFetch = null;
      }
      
      this.isLoading = false;
      this.classList.remove('loading');
      
      if (this.drawer) {
        this.drawer.classList.remove('active');
      }
      
      this.body.classList.remove('open-cc');
      this.body.classList.remove('open-quick-view');
    }
    
    renderQuickview(sectionInnerHTML, productHandle) {
      if (!sectionInnerHTML || !this.drawer) {
        if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
          console.warn('renderQuickview: Missing content or drawer', { 
            hasContent: !!sectionInnerHTML, 
            hasDrawer: !!this.drawer 
          });
        }
        return;
      }
      
      // Verificar si el drawer sigue abierto (puede haberse cerrado durante la carga)
      if (!this.drawer.classList.contains('active')) {
        if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
          console.log('renderQuickview: Drawer was closed during load');
        }
        return;
      }
      
      const content = this.drawer.querySelector('#Product-Drawer-Content');
      if (!content) {
        if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
          console.error('renderQuickview: #Product-Drawer-Content not found in drawer');
        }
        return;
      }
      
      // Debug: verificar contenido antes de inyectar
      if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
        console.log('renderQuickview: Injecting content', {
          contentLength: sectionInnerHTML.length,
          contentPreview: sectionInnerHTML.substring(0, 200)
        });
      }
      
      // Debug: verificar contenido antes de inyectar
      if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sectionInnerHTML;
        const productInfoBefore = tempDiv.querySelector('#ProductInfo-main-product-quick-view');
        console.log('Before injection:', {
          productInfoExists: !!productInfoBefore,
          productInfoLength: productInfoBefore?.innerHTML?.length || 0,
          productInfoPreview: productInfoBefore?.innerHTML?.substring(0, 200) || 'empty'
        });
      }
      
      // Limpiar loading state e inyectar contenido
      content.innerHTML = sectionInnerHTML;
      
      // Debug: verificar contenido después de inyectar
      if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
        const productInfoAfter = content.querySelector('#ProductInfo-main-product-quick-view');
        console.log('After injection:', {
          productInfoExists: !!productInfoAfter,
          productInfoLength: productInfoAfter?.innerHTML?.length || 0,
          productInfoPreview: productInfoAfter?.innerHTML?.substring(0, 200) || 'empty',
          allChildren: Array.from(content.children).map(el => el.tagName + (el.id ? '#' + el.id : ''))
        });
      }

      // Procesar scripts de forma optimizada
      const scripts = content.querySelectorAll('script');
      const scriptsToLoad = [];
      
      scripts.forEach((script) => {
        if (script.src) {
          // Verificar si el script ya está cargado
          if (!document.querySelector(`script[src="${script.src}"]`)) {
            scriptsToLoad.push(script.src);
          }
        } else if (script.textContent) {
          // Ejecutar scripts inline de forma más robusta
          try {
            // Crear un script nuevo y ejecutarlo en el contexto del documento
            const newScript = document.createElement('script');
            newScript.textContent = script.textContent;
            // Insertar en el body en lugar del head para mejor compatibilidad
            document.body.appendChild(newScript);
            document.body.removeChild(newScript);
          } catch (e) {
            console.warn('Error executing inline script:', e);
          }
        }
      });
      
      // Disparar evento personalizado para que otros scripts puedan reaccionar
      if (typeof window.dispatchEvent !== 'undefined') {
        const event = new CustomEvent('quick-view:content-loaded', {
          detail: { productHandle, content }
        });
        window.dispatchEvent(event);
      }
      
      // Asegurar que los variant-selects se inicialicen correctamente en el quick view
      // SIGUIENDO EXACTAMENTE EL MISMO FLUJO QUE EN LAS PÁGINAS DE PRODUCTO NORMALES
      // En las páginas normales, cuando variant-selects se añade al DOM, se ejecuta automáticamente:
      // 1. constructor() -> initializeReferences()
      // 2. connectedCallback() -> updateOptions(), updateMasterId(), setDisabled(), setImageSet()
      // 
      // Cuando se inyecta dinámicamente, el navegador puede no ejecutar connectedCallback automáticamente,
      // especialmente en modo incógnito. Por lo tanto, debemos asegurarnos de que se ejecute.
      requestAnimationFrame(() => {
        // Dar tiempo para que el DOM se estabilice y los custom elements se "upgradeen"
        setTimeout(() => {
          const variantSelects = content.querySelector('variant-selects');
          
          console.log('[quick-view] Looking for variant-selects:', {
            found: !!variantSelects,
            contentLength: content.innerHTML.length,
            hasVariations: !!content.querySelector('.variations'),
            customElementDefined: !!customElements.get('variant-selects'),
            productScriptInDOM: !!document.querySelector('script[src*="product.js"]'),
            allCustomElements: Array.from(content.querySelectorAll('variant-selects')).map(el => ({
              section: el.dataset.section,
              hasConnectedCallback: typeof el.connectedCallback === 'function',
              hasInitializeReferences: typeof el.initializeReferences === 'function'
            }))
          });
          
          if (!variantSelects) {
            console.warn('[quick-view] variant-selects not found in content');
            return;
          }
          
          // CRÍTICO: Verificar SIEMPRE si el custom element está definido antes de proceder
          // Esto es necesario porque product.js puede no estar cargado si enable_quick_view
          // o enable_quick_add están deshabilitados en la configuración del tema
          const customElementDefined = !!customElements.get('variant-selects');
          if (!customElementDefined) {
            console.warn('[quick-view] variant-selects custom element not defined. This usually means product.js is not loaded.');
            console.log('[quick-view] Attempting to load product.js dynamically...');
          }
          
          // Estrategia: Asegurar que product.js esté cargado y el custom element esté definido
          // antes de intentar inicializarlo
          // IMPORTANTE: Esto es necesario porque product.js solo se carga si enable_quick_view
          // o enable_quick_add están habilitados, o si hay productos en el carrito
          const ensureScriptLoaded = () => {
            // Verificar si el custom element está definido (esto es la verificación más confiable)
            const customElementDefined = !!customElements.get('variant-selects');
            // Verificar si el script product.js está en el DOM (puede estar con defer)
            const productScriptInDOM = document.querySelector('script[src*="product.js"]');
            // Verificar si el script ya se está cargando dinámicamente
            const scriptLoading = document.querySelector('script[data-dynamic-load="product.js"]');
            
            console.log('[quick-view] Checking script and custom element:', {
              productScriptInDOM: !!productScriptInDOM,
              scriptLoading: !!scriptLoading,
              customElementDefined: customElementDefined,
              variantSelectsExists: !!variantSelects,
              enableQuickView: typeof window.theme !== 'undefined' ? window.theme.settings?.enable_quick_view : 'unknown',
              enableQuickAdd: typeof window.theme !== 'undefined' ? window.theme.settings?.enable_quick_add : 'unknown'
            });
            
            // Si el custom element no está definido, necesitamos cargar el script
            if (!customElementDefined) {
              // Si el script no está en el DOM y no se está cargando, cargarlo dinámicamente
              if (!productScriptInDOM && !scriptLoading) {
                console.log('[quick-view] product.js not in DOM and not loading, loading now...');
                const script = document.createElement('script');
                
                // Construir la ruta correcta basada en la estructura de Shopify
                // Intentar obtener la ruta desde app.js primero
                const appScript = document.querySelector('script[src*="app.js"]');
                if (appScript) {
                  // Extraer la ruta base y construir la ruta de product.js
                  const appSrc = appScript.src;
                  // La ruta de Shopify suele ser: /cdn/shop/t/{theme_id}/assets/{filename}
                  script.src = appSrc.replace('app.js', 'product.js');
                } else {
                  // Fallback: intentar construir la ruta desde otros scripts
                  const anyAssetScript = document.querySelector('script[src*="/assets/"]');
                  if (anyAssetScript) {
                    const match = anyAssetScript.src.match(/^(.+\/assets\/)/);
                    if (match) {
                      script.src = match[1] + 'product.js';
                    } else {
                      // Último fallback: usar la ruta estándar de Shopify
                      script.src = '/cdn/shop/t/122/assets/product.js';
                    }
                  } else {
                    // Último fallback absoluto
                    script.src = '/cdn/shop/t/122/assets/product.js';
                  }
                }
                
                // Marcar el script como cargándose dinámicamente para evitar cargas duplicadas
                script.setAttribute('data-dynamic-load', 'product.js');
                console.log('[quick-view] Loading product.js from:', script.src);
                script.defer = false; // Cargar inmediatamente, no defer
                script.async = false; // No async para asegurar orden de ejecución
                
                script.onload = () => {
                  console.log('[quick-view] product.js loaded successfully, waiting for custom element...');
                  // Remover el atributo de carga dinámica ya que se cargó
                  script.removeAttribute('data-dynamic-load');
                  
                  // Esperar un momento para que el script se ejecute completamente
                  setTimeout(() => {
                    // Verificar si el custom element se definió
                    const nowDefined = !!customElements.get('variant-selects');
                    console.log('[quick-view] After script load, custom element defined:', nowDefined);
                    
                    if (nowDefined) {
                      ensureInitialized();
                    } else {
                      // Esperar a que el custom element se defina después de cargar el script
                      if (customElements && typeof customElements.whenDefined === 'function') {
                        customElements.whenDefined('variant-selects').then(() => {
                          console.log('[quick-view] Custom element now defined after script load');
                          ensureInitialized();
                        }).catch(err => {
                          console.warn('[quick-view] Error waiting for custom element after script load:', err);
                          // Intentar de nuevo después de un delay
                          setTimeout(ensureInitialized, 200);
                        });
                      } else {
                        // Fallback: esperar un poco y luego intentar
                        setTimeout(ensureInitialized, 200);
                      }
                    }
                  }, 100); // Pequeño delay para asegurar que el script se ejecutó
                };
                
                script.onerror = () => {
                  console.error('[quick-view] Error loading product.js from:', script.src);
                  // Intentar con una ruta alternativa o de nuevo después de un delay
                  setTimeout(() => {
                    console.log('[quick-view] Retrying script load...');
                    ensureScriptLoaded();
                  }, 500);
                };
                
                document.head.appendChild(script);
                return;
              } else {
                // El script está en el DOM pero el custom element aún no está definido
                // Esto puede pasar si el script tiene defer y aún no se ha ejecutado
                console.log('[quick-view] product.js in DOM but custom element not defined, waiting...');
                
                // Esperar a que el script se ejecute (si tiene defer) o que el custom element se defina
                if (customElements && typeof customElements.whenDefined === 'function') {
                  // Usar un timeout como fallback en caso de que whenDefined no funcione
                  const timeoutId = setTimeout(() => {
                    console.warn('[quick-view] Timeout waiting for custom element, retrying...');
                    ensureScriptLoaded();
                  }, 2000);
                  
                  customElements.whenDefined('variant-selects').then(() => {
                    clearTimeout(timeoutId);
                    console.log('[quick-view] Custom element now defined');
                    ensureInitialized();
                  }).catch(err => {
                    clearTimeout(timeoutId);
                    console.warn('[quick-view] Error waiting for custom element:', err);
                    setTimeout(ensureInitialized, 200);
                  });
                } else {
                  // Fallback: intentar después de un delay
                  setTimeout(ensureInitialized, 200);
                }
                return;
              }
            }
            
            // Si llegamos aquí, el custom element está definido, proceder con la inicialización
            ensureInitialized();
          };
          
          // Estrategia: Esperar a que el custom element esté completamente definido y luego
          // ejecutar connectedCallback que contiene toda la lógica de inicialización
          const ensureInitialized = () => {
            console.log('[quick-view] ensureInitialized called:', {
              customElementDefined: !!customElements.get('variant-selects'),
              variantSelectsExists: !!variantSelects,
              hasConnectedCallback: typeof variantSelects.connectedCallback === 'function',
              hasInitializeReferences: typeof variantSelects.initializeReferences === 'function',
              hasUpdateOptions: typeof variantSelects.updateOptions === 'function',
              hasSetImageSet: typeof variantSelects.setImageSet === 'function'
            });
            
            // Verificar que el custom element esté completamente inicializado
            if (!customElements.get('variant-selects')) {
              console.log('[quick-view] Custom element not yet defined in ensureInitialized, retrying...');
              // Si el custom element aún no está definido, volver a verificar el script
              setTimeout(ensureScriptLoaded, 100);
              return;
            }
            
            // Asegurar que las referencias estén correctas (el elemento puede haber sido movido)
            if (typeof variantSelects.initializeReferences === 'function') {
              const correctWrapper = this.drawer.querySelector('.thb-product-detail');
              console.log('[quick-view] Checking references:', {
                hasProductWrapper: !!variantSelects.productWrapper,
                correctWrapper: !!correctWrapper,
                wrappersMatch: variantSelects.productWrapper === correctWrapper
              });
              
              if (!variantSelects.productWrapper || variantSelects.productWrapper !== correctWrapper) {
                console.log('[quick-view] Re-initializing references');
                variantSelects.initializeReferences();
                console.log('[quick-view] After initializeReferences:', {
                  hasProductWrapper: !!variantSelects.productWrapper,
                  hasProductSlider: !!variantSelects.productSlider,
                  hideVariants: variantSelects.hideVariants
                });
              }
            }
            
            // Ejecutar connectedCallback que contiene toda la lógica de inicialización
            // Esto es EXACTAMENTE lo que hace el navegador en páginas normales:
            // 1. initializeReferences() (si es necesario)
            // 2. updateOptions()
            // 3. updateMasterId()
            // 4. setDisabled()
            // 5. setImageSet() -> setImageSetMedia() (filtra imágenes por variante)
            console.log('[quick-view] About to execute connectedCallback:', {
              section: variantSelects.dataset.section,
              hasProductWrapper: !!variantSelects.productWrapper,
              hasProductSlider: !!variantSelects.productSlider,
              hideVariants: variantSelects.hideVariants,
              hasVariations: !!variantSelects.querySelector('.variations'),
              variationsChildren: variantSelects.querySelector('.variations')?.children.length || 0
            });
            
            if (typeof variantSelects.connectedCallback === 'function') {
              try {
                variantSelects.connectedCallback();
                console.log('[quick-view] connectedCallback executed successfully');
                
                // Verificar que setImageSet se haya ejecutado
                console.log('[quick-view] After connectedCallback:', {
                  imageSetName: variantSelects.imageSetName,
                  imageSetIndex: variantSelects.imageSetIndex,
                  currentVariant: variantSelects.currentVariant ? {
                    id: variantSelects.currentVariant.id,
                    title: variantSelects.currentVariant.title
                  } : null,
                  options: variantSelects.options
                });
                
                // CRÍTICO: Después de connectedCallback, asegurar que los event listeners
                // estén registrados directamente en los inputs para Edge y modo incógnito
                // Esto es necesario porque algunos navegadores no ejecutan el bubbling correctamente
                // cuando el contenido se inyecta dinámicamente
                setTimeout(() => {
                  const variations = variantSelects.querySelector('.variations');
                  if (variations) {
                    const allInputs = variations.querySelectorAll('input[type="radio"], input[type="checkbox"], select');
                    console.log('[quick-view] Registering direct listeners on inputs after connectedCallback:', {
                      totalInputs: allInputs.length
                    });
                    
                    allInputs.forEach((input) => {
                      // Solo registrar si no tiene ya un listener
                      if (!input.hasAttribute('data-change-listener-registered')) {
                        const directHandler = (e) => {
                          console.log('[quick-view] Direct input change event:', {
                            inputName: e.target.name,
                            inputValue: e.target.value,
                            inputType: e.target.type
                          });
                          // Llamar al handler principal del variant-selects
                          if (variantSelects._changeHandler) {
                            variantSelects._changeHandler(e);
                          } else if (typeof variantSelects.onVariantChange === 'function') {
                            variantSelects.onVariantChange(e);
                          }
                        };
                        input.addEventListener('change', directHandler);
                        input.setAttribute('data-change-listener-registered', 'true');
                      }
                    });
                    console.log('[quick-view] Direct listeners registered on', allInputs.length, 'inputs');
                  }
                }, 50); // Pequeño delay para asegurar que el DOM esté completamente listo
              } catch (e) {
                console.error('[quick-view] Error executing connectedCallback:', e);
                console.error('[quick-view] Error stack:', e.stack);
              }
            } else {
              console.warn('[quick-view] connectedCallback is not a function:', typeof variantSelects.connectedCallback);
              
              // Fallback: ejecutar métodos manualmente si connectedCallback no está disponible
              console.log('[quick-view] Attempting manual initialization as fallback');
              if (typeof variantSelects.updateOptions === 'function') {
                variantSelects.updateOptions();
                console.log('[quick-view] updateOptions executed');
              }
              if (typeof variantSelects.updateMasterId === 'function') {
                variantSelects.updateMasterId();
                console.log('[quick-view] updateMasterId executed');
              }
              if (typeof variantSelects.setDisabled === 'function') {
                variantSelects.setDisabled();
                console.log('[quick-view] setDisabled executed');
              }
              if (typeof variantSelects.setImageSet === 'function') {
                variantSelects.setImageSet();
                console.log('[quick-view] setImageSet executed');
              }
            }
            
            // Después de connectedCallback, asegurar que la imagen inicial esté correctamente mostrada
            // En páginas normales, el HTML ya viene con is-active, pero después de setImageSetMedia()
            // puede que necesitemos asegurar que la imagen de la variante inicial esté visible
            if (variantSelects.currentVariant && variantSelects.currentVariant.featured_media) {
              console.log('[quick-view] Updating initial media for variant:', {
                variantId: variantSelects.currentVariant.id,
                variantTitle: variantSelects.currentVariant.title,
                featuredMediaId: variantSelects.currentVariant.featured_media.id
              });
              
              // Actualizar la imagen visible para la variante inicial (similar a updateMedia en onVariantChange)
              if (typeof variantSelects.updateMedia === 'function') {
                try {
                  variantSelects.updateMedia();
                  console.log('[quick-view] updateMedia executed successfully');
                } catch (e) {
                  console.warn('[quick-view] Error updating initial media:', e);
                }
              }
            } else {
              console.log('[quick-view] No currentVariant or featured_media to update');
            }
            
            // Después de actualizar la imagen, asegurar que el botón esté en el estado correcto
            // Esto es similar a lo que hace renderProductInfo() en onVariantChange
            if (variantSelects.currentVariant) {
              if (typeof variantSelects.renderProductInfo === 'function') {
                // renderProductInfo actualiza precio y botón basado en la variante actual
                variantSelects.renderProductInfo();
              } else if (typeof variantSelects.toggleAddButton === 'function') {
                // Fallback si renderProductInfo no está disponible
                variantSelects.toggleAddButton(
                  !variantSelects.currentVariant.available,
                  variantSelects.currentVariant.available ? '' : (window.theme?.variantStrings?.soldOut || 'Sold out')
                );
              }
            } else {
              // Si no hay variante disponible, deshabilitar botón
              if (typeof variantSelects.toggleAddButton === 'function') {
                variantSelects.toggleAddButton(true, '', true);
              }
              if (typeof variantSelects.setUnavailable === 'function') {
                variantSelects.setUnavailable();
              }
            }
          };
          
          // Iniciar el proceso de inicialización
          // Primero verificar que el script esté cargado, luego inicializar
          ensureScriptLoaded();
        }, 100);
      });
      
      // Cargar scripts externos de forma asíncrona
      if (scriptsToLoad.length > 0) {
        Promise.all(scriptsToLoad.map(src => {
          return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.onload = resolve;
            script.onerror = resolve; // Continuar aunque falle
            document.head.appendChild(script);
          });
        })).then(() => {
          // Inicializar componentes después de cargar scripts
          this.initializeComponents();
        });
      } else {
        this.initializeComponents();
      }
      
      // Animar imágenes después de un breve delay
      setTimeout(() => {
        const imagesContainer = this.drawer.querySelector('.product-quick-images--container');
        if (imagesContainer) {
          imagesContainer.classList.add('active');
        }
      }, 100);
      
      // Construir URL del producto usando ruta relativa
      const productUrl = `/products/${productHandle}`;
      
        dispatchCustomEvent('quick-view:open', {
        productUrl: productUrl,
          productHandle: productHandle
        });
      
      if (typeof addIdToRecentlyViewed === 'function') {
        addIdToRecentlyViewed(productHandle);
      }
      
      this.isLoading = false;
      this.classList.remove('loading');
    }
    
    /**
     * Inicializar componentes de Shopify
     */
    initializeComponents() {
      // Usar requestAnimationFrame para mejor performance
      requestAnimationFrame(() => {
        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) {
          window.ProductModel.loadShopifyXR();
        }
      });
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      const summary = this.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (e) => this.onClick(e));
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && recentIds !== 'undefined' && recentIds !== 'null' && recentIds.trim() !== '') {
      try {
        window.recentlyViewedIds = JSON.parse(recentIds);
      } catch (e) {
        console.error('Error parsing recently-viewed from localStorage:', e);
        window.recentlyViewedIds = [];
        window.localStorage.removeItem('recently-viewed');
      }
    } else {
      window.recentlyViewedIds = [];
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});